export const BX_HYBRID_SEARCH_EXPERIMENT = 'vx_desktop_bx_365_hybrid_listing';
export const BX_MAP_UPDATE_EXPERIMENT = 'vx_desktop_bx_639_map_update';

export const EXPERIMENTS: string[] = [BX_HYBRID_SEARCH_EXPERIMENT, BX_MAP_UPDATE_EXPERIMENT];
